
import { useProjectActions, useProjectContext } from "@contexts/projects";
import { useAuthActions } from "@contexts/auth";
import { useEffect, useState } from "react";
import useAdminCheck from "@helpers/adminCheck";
import { permissionRoles, permissionsTokens } from "@utils/permissions";
import { useBimActions } from "@contexts/bim";


const emptyUser = {
  name: '',
  email: '',
  password: 'ampli2024#',
  roles: [],
  companyId: [],
  buildingIds: [],
  bimProjectsIds: []
}

// onSuccess: opcional — usado quando este formulário é aberto num Modal a partir da tela de
// Usuários, para fechar o modal e recarregar a listagem.
const NewUser = ({ onSuccess }) => {
  const [newUser, setNewUser] = useState(emptyUser)
  const [companies, setCompanies] = useState([])
  const [buildings, setBuildings] = useState([])
  const [bimProjects, setBimProjects] = useState([])
  const { getProjects } = useBimActions();
  const { listCompanies } = useProjectActions();
  const { createUser } = useAuthActions();
  const [resMsg, setResMsg] = useState('')

  // useAdminCheck()

  const getBim = async () => {
    const res = await getProjects('all');
    setBimProjects(res.res)
  }

  const getCompanies = async () => {
    const res = await listCompanies();
    setCompanies(res.companies)
    setBuildings(res.buildings)
  }

  useEffect(() => {
    getCompanies();
    getBim();
  }, [])

  const handleInput = (e) => {
    setNewUser(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSend = async (e) => {
    e.preventDefault()
    const companies = newUser.companyId.map(i => {
      return { _id: i }
    })
    const res = await createUser({ ...newUser, companyId: companies });
    setResMsg(res.message)
    document.getElementById("resMessage")?.scrollIntoView({ behavior: "smooth" })
    if (res.code === 200) setNewUser(emptyUser)
    onSuccess?.({ ok: res.code === 200, message: res.message })
  }

  const handleType = (e) => {
    const { value } = e.target;
    const { roles } = newUser;
    if (!roles.includes(value)) {
      setNewUser(prev => ({
        ...prev,
        roles: [...roles, value]
      }));
    } else {
      const newRoles = roles.filter(i => i !== value);
      setNewUser(prev => ({
        ...prev,
        roles: newRoles
      }));
    }
  }

  const handleCompany = (e) => {
    const { value } = e.target;
    const userCompanies = newUser.companyId;
    if (!userCompanies.includes(value)) {
      setNewUser(prev => ({
        ...prev,
        companyId: [...userCompanies, value]
      }));
    } else {
      const updatedCompanies = userCompanies.filter(company => company !== value);
      const updatedBuildings = newUser.buildingIds.filter(buildingId => {
        const building = buildings.find(b => b._id === buildingId);
        return building && building.company_id !== value;
      });
      setNewUser(prev => ({
        ...prev,
        companyId: updatedCompanies,
        buildingIds: updatedBuildings
      }));
    }
  }

  const handleBuilding = (e) => {
    const { value } = e.target;
    const userBuildings = newUser.buildingIds;
    if (!userBuildings.includes(value)) {
      setNewUser(prev => ({
        ...prev,
        buildingIds: [...userBuildings, value]
      }));
    } else {
      const updatedBuildings = userBuildings.filter(i => i !== value);
      setNewUser(prev => ({
        ...prev,
        buildingIds: updatedBuildings
      }));
    }
  }

  const handleBimProject = (e) => {
    const { value } = e.target;
    const userProjects = newUser.bimProjectsIds;
    if (!userProjects.includes(value)) {
      setNewUser(prev => ({
        ...prev,
        bimProjectsIds: [...userProjects, value]
      }));
    } else {
      const updatedProjects = userProjects.filter(i => i !== value);
      setNewUser(prev => ({
        ...prev,
        bimProjectsIds: updatedProjects
      }));
    }
  }

  return (
    <>
      <div>
        <form className="new-user-container">
          <label>Nome</label>
          <input type="text" name='name' onChange={handleInput} value={newUser.name} />
          <label>E-mail</label>
          <input type="text" name='email' onChange={handleInput} value={newUser.email} />
          <h2>Permissões</h2>
          <div className="companies grid gap-16 columns-3-tablet align-center">
            {permissionRoles.map(i => {
              return <div key={i.value}>
                <input type="checkbox" value={i.value} onChange={handleType} />
                <label>{i.name}</label>
              </div>
            })}
          </div>
          <h2>Construtoras</h2>
          <div className="companies grid gap-16 columns-3-tablet align-center">
            {companies.map(i => {
              return <div key={`${i._id}`}>
                <input type="checkbox" value={`${i._id}`} onChange={handleCompany} />
                <label>{i.name}</label>
              </div>
            })}
          </div>
          <h2>Obras</h2>
          <div className="companies grid gap-16 columns-4-tablet align-center">
            {buildings.filter(i => newUser.companyId.includes(i.company_id)).map(i => {
              return <div key={`${i._id}`}>
                <input onChange={handleBuilding} checked={newUser.buildingIds.includes(i._id)} type="checkbox" value={`${i._id}`} />
                <label>{i.building_name}</label>
              </div>
            })}
          </div>
          {(newUser.roles.includes('bim') || newUser.roles.includes('bimAdmin')) && <>
            <h2>Projetos BIM</h2>
            <div className="companies grid gap-16 columns-4-tablet align-center">
              {bimProjects.map(i => {
                return <div key={i._id}>
                  <input type="checkbox" value={i._id} checked={newUser?.bimProjectsIds?.includes(i._id)} onChange={handleBimProject} />
                  <label>{i.name}</label>
                </div>
              })}
            </div>
          </>}
          <button disabled={newUser.name === '' || newUser.email === "" || newUser.companyId.length === 0} className="button button-accent" onClick={handleSend}>Enviar</button>

          <span id="resMessage" style={{ marginLeft: '32px', fontSize: '22px', fontWeight: 'bold' }}>{resMsg}</span>
        </form>
      </div>
    </>
  );
};

export default NewUser;
